module.exports = __webpack_public_path__ + "static/media/mePic.53d29470.jpg";